import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import masterPP from '~/scopes/product-core/middleware/masterPP/masterPP'
import redirectInvalidUUID from '~/scopes/product-core/middleware/redirectInvalidUUID/redirectInvalidUUID'
import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

export default (): RouteRecordRaw[] => {
  const { FF_PRODUCT_PAGE_ENABLED_DEV_ONLY_PAGES } = useRuntimeConfig().public

  return [
    {
      component: () =>
        import('~/scopes/product-core/pages/ProductProxy/ProductProxy.vue'),
      name: PRODUCT_ROUTES.VARIANT_PRODUCT_PAGE,
      path: 'p/:slugV2/:uuid',
      meta: {
        middleware: [redirectInvalidUUID],
        owners: ['bot-squad-product-page-front'],
        cache: 'public, max-age=90000, stale-while-revalidate=90000',
      },
    },
    {
      component: () =>
        import('~/scopes/product-core/pages/ProductProxy/ProductProxy.vue'),
      name: PRODUCT_ROUTES.MASTER_PRODUCT_PAGE,
      path: 'p/:slug',
      meta: {
        middleware: [masterPP],
        owners: ['bot-squad-product-page-front'],
        cache: 'public, max-age=90000, stale-while-revalidate=90000',
      },
    },
    // Dev only routes
    {
      component: () =>
        import(
          '~/scopes/product-core/pages/ProductProxy/ProductProxyDevOnly.vue'
        ),
      name: PRODUCT_ROUTES.DEV_ONLY_VARIANT_PRODUCT_PAGE,
      path: 'dev/p/:slugV2/:uuid',
      meta: {
        routeExists: () => FF_PRODUCT_PAGE_ENABLED_DEV_ONLY_PAGES || false,
        middleware: [redirectInvalidUUID],
        owners: ['bot-squad-product-page-front'],
        cache: 'public, max-age=90000, stale-while-revalidate=90000',
      },
    },
    {
      component: () =>
        import(
          '~/scopes/product-core/pages/ProductProxy/ProductProxyDevOnly.vue'
        ),
      name: PRODUCT_ROUTES.DEV_ONLY_MASTER_PRODUCT_PAGE,
      path: 'dev/p/:slug',
      meta: {
        routeExists: () => FF_PRODUCT_PAGE_ENABLED_DEV_ONLY_PAGES || false,
        middleware: [masterPP],
        owners: ['bot-squad-product-page-front'],
        cache: 'public, max-age=90000, stale-while-revalidate=90000',
      },
    },
    // Webviews
    {
      component: () =>
        import(
          '~/scopes/product/components/CustomizationFunnel/components/VisibleByVerizonDrawer/components/VisibleByVerizonDrawerBody/VisibleByVerizonDrawerBody.vue'
        ),
      name: PRODUCT_ROUTES.WEBVIEWS_VISIBLE_BY_VERIZON_DRAWER,
      path: 'p/drawers/visible-by-verizon',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
    {
      component: () =>
        import(
          '~/scopes/product/components/CustomizationFunnel/components/ProcessorModal/ProcessorModalBody/ProcessorModalBody.vue'
        ),
      name: PRODUCT_ROUTES.WEBVIEWS_PROCESSOR_DRAWER,
      path: 'p/drawers/processor',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
    {
      component: () =>
        import(
          '~/scopes/product-core/components/presentationals/ReassuranceItems/components/ItemObsoleteComputer/components/ObsoleteComputerModalBody/ObsoleteComputerModalBody.vue'
        ),
      name: PRODUCT_ROUTES.WEBVIEWS_OBSOLETE_DRAWER,
      path: 'p/drawers/obsolete',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
  ]
}
